interface AlertProps {
  title: string;
  color?: string;
  titleBgColor?: string;
  bodyBgColor?: string;
  bodyBorderColor?: string;
  bodyTextColor?: string;
  style?: any;
  children: any;
}

export default function Alert(props: AlertProps) {
  const color = props.color || "green";
  const titleBgColor = props.titleBgColor || `bg-${color}-500`;
  const bodyBgColor = props.bodyBgColor || `bg-${color}-100`;
  const bodyBorderColor = props.bodyBorderColor || `border-${color}-400`;
  const bodyTextColor = props.bodyTextColor || `text-${color}-700`;

  return (
    <div className={`w-full mb-4`} role="alert" style={props.style}>
      <div
        className={`${titleBgColor} text-white font-bold rounded-t px-4 py-4`}
      >
        <span>{props.title}</span>
      </div>
      <div
        className={`${bodyBgColor} border ${bodyBorderColor} ${bodyTextColor} px-4 py-3 rounded-b relative p-t5`}
      >
        {props.children}
      </div>
    </div>
  );
}
